import { createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
import { defineComponent } from "vue";
import championShowTitleUrl from "@/assets/img/m/homePage/champion-show-title.png";
// components
import SelectBtn from "@/components/m/common/select-btns.vue";
import MemberList from "@/components/m/member-list/member-list.vue";
//hooks
import useHomePageChampionShow from "@/hooks/home-page-champion-show";
import { raceQuarterOptM, groupTypeOptM } from "@/config/homePage";
export default defineComponent({
  name: "MChampionShow",
  setup() {
    const {
      championShowState,
      raceQuarterSwitchFct,
      groupSwitchFct
    } = useHomePageChampionShow();
    return () => {
      return _createVNode("div", null, [_createVNode("div", {
        "class": "champion-show-box"
      }, [_createVNode("div", {
        "class": "title-box"
      }, [_createVNode("img", {
        "class": "title",
        "src": championShowTitleUrl
      }, null)]), _createVNode("div", {
        "class": "select-btn"
      }, [_createVNode(SelectBtn, {
        "onClick": raceQuarterSwitchFct,
        "options": raceQuarterOptM,
        "dataValue": championShowState.raceQuartertype
      }, null), _createVNode(SelectBtn, {
        "class": "btn-center",
        "onClick": groupSwitchFct,
        "options": groupTypeOptM,
        "dataValue": championShowState.groupType,
        "defaultOption": groupTypeOptM[championShowState.groupType - 1]
      }, null)]), Object.keys(championShowState.teamInfo).length ? _createVNode("div", null, [_createVNode("div", {
        "class": "champion-name-box"
      }, [_createVNode("div", {
        "class": "champion-name-sub"
      }, [_createTextVNode("\u661F\u706B\u8054\u8D5B\u7B2C"), championShowState.raceQuartertype, _createTextVNode("\u5C4A"), groupTypeOptM.filter(item => item.value == championShowState.groupType)[0].label, " ", _createTextVNode("\u51A0\u519B")]), _createVNode("div", {
        "class": "champion-name"
      }, [championShowState.teamInfo.match_team_name, _createTextVNode(" \u6218\u961F")])]), _createVNode(MemberList, {
        "teamData": championShowState.teamInfo.match_player_info
      }, null)]) : _createVNode("div", {
        "class": "not-finished"
      }, [_createTextVNode("\u656C\u8BF7\u671F\u5F85\xB7\xB7\xB7\xB7")])])]);
    };
  }
});